import throttle from "lodash.throttle";

class Navigation {
    constructor() {
        this.nav = document.querySelector('.site-header');
        if (!this.nav) return;

        this.topOfNav = this.nav.offsetTop;
        window.addEventListener("scroll", throttle(() => this.toggleFixedNav(), 10));
        this.setupMobileMenu();
    }

    toggleFixedNav() {
        const isScrolled = window.scrollY >= 220;
        document.body.classList.toggle('fixed-nav', isScrolled);
        document.body.style.paddingTop = isScrolled ? this.nav.offsetHeight + 'px' : '0';
    }

    setupMobileMenu() {
        const elements = {
            closeOverlay: document.querySelector('.close-sidebars-overlay'),
            closeMenu: document.querySelector('.close-sidebars-menu'),
            openButton: document.getElementById('toggleNav'),
            mobileMenu: document.querySelector('.sidebar-mobile-menu'),
            submenus: document.querySelectorAll('.open-submenu')
        };

        elements.openButton.addEventListener('click', () => this.toggleMobileMenu(elements, true));
        elements.closeOverlay.addEventListener('click', () => this.toggleMobileMenu(elements, false));
        elements.closeMenu.addEventListener('click', () => this.toggleMobileMenu(elements, false));

        elements.submenus.forEach(item => {
            item.addEventListener('click', () => {
                item.parentElement.classList.toggle('nested-submenu--opened');
                this.toggle(item.nextElementSibling);
            });
        });
    }

    toggleMobileMenu(elements, isOpen) {
        document.body.classList.toggle('mobile-opened', isOpen);
        elements.mobileMenu.classList.toggle('sidebar-fixed--opened', isOpen);
        elements.closeOverlay.classList.toggle('close-sidebars-overlay--opened', isOpen);
    }

    toggle(elem) {
        elem.classList.toggle('is-visible');
        elem.style.height = elem.classList.contains('is-visible') ? elem.scrollHeight + 'px' : '0';
    }
}

export default Navigation;